import React, { useEffect, useRef, useState } from 'react'
import styles from './CustomSelect.module.scss'
import { ReactComponent as SelectComponent } from 'components/ContentBox/img/arrow-botom.svg'

const CustomSelect = ({
  options,
  onSelect,
  defaultValue,
  placeholder,
  dropdownMaxHeight,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState(defaultValue || '')

  const dropdownRef = useRef(null)

  const handleOptionClick = (option) => {
    setSelectedOption(option)
    setIsOpen(false)
    if (onSelect) onSelect(option)
  }

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false) // Закрываем dropdown, если клик был вне компонента
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className={styles.container} ref={dropdownRef} tabIndex='0'>
      <div
        className={styles.selected}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <div className={styles.selectData}>
          <div className={styles.data}>{selectedOption || placeholder}</div>
          <div className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`}>
            <SelectComponent />
          </div>
        </div>
      </div>
      {isOpen && (
        <div
          className={styles.dropdown}
          style={dropdownMaxHeight ? { height: dropdownMaxHeight } : {}}
        >
          {options.map((option, index) => (
            <div
              key={index}
              className={styles.optionItem}
              tabIndex='0'
              onClick={() => handleOptionClick(option)}
            >
              <div className={styles.optionText}>
                {option}
                <div className={styles.line}></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default CustomSelect
